import InvitationsScreen from './InvitationsScreen';

export const PrototypeInvitationsScreen = (props: any) => (
  <InvitationsScreen {...props} sessionType="prototype_sprint" />
);

export default PrototypeInvitationsScreen;
